import DeleteIcon from "@mui/icons-material/DeleteOutlineRounded";
import { Button } from "@mui/material";
import ActionsMenuButton from "@entrilia/shared/components/ActionsMenuButton";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import GeneralPageHeader from "../../../common/GeneralPageHeader";
import InvestorPortalImpersonateButton from "../../investor-portal/InvestorPortalImpersonateButton";
import InvestorCommunicationPageTitle from "../InvestorCommunicationPageTitle";
import { getPublishTransition, getUnpublishTransition } from "../investorCommunicationStatusHelper";
import InvestorCommunicationContext from "./InvestorCommunicationContext";

const InvestorCommunicationDetailsPageHeader = () => {
  const {
    investorCommunication,
    recipients,
    hasEditPermissions,
    isNewsVisibleToInvestors,
    hasChanges,
    isSaveAllowed,
    isSaving,
    hasPendingImageUploads,
    pendingSaveAction,
    selectedTab,
    onStatusChange,
    onDelete,
    onDiscardChanges,
    onSave,
    onSaveAndExit,
  } = useDefinedContext(InvestorCommunicationContext, "InvestorCommunicationContext");

  const publishTransition = getPublishTransition(investorCommunication.status, isNewsVisibleToInvestors);
  const unpublishTransition = getUnpublishTransition(investorCommunication.status);

  const isSummaryTab = selectedTab === "summary";
  const isCancelDisabled = isSummaryTab || !hasChanges || isSaving || hasPendingImageUploads;
  const isSaveDisabled = isSummaryTab || !isSaveAllowed || isSaving;
  const isStatusChangeDisabled = hasChanges || isSaving || hasPendingImageUploads;

  const validUserEmail = recipients.find((recipient) => !!recipient.contactEmail)?.contactEmail;

  return (
    <GeneralPageHeader
      hideBorderLine
      showDefaultBackButtonTo=".."
      TitleComponent={<InvestorCommunicationPageTitle investorCommunication={investorCommunication} />}
    >
      {["Live", "Preview"].includes(investorCommunication.status) && (
        <InvestorPortalImpersonateButton
          variant="outlined"
          color="secondary"
          disabled={!validUserEmail}
          disabledTooltipText="No user with a valid email found from the recipients list"
          params={{ target: "Investor", userEmail: validUserEmail }}
        />
      )}

      {hasEditPermissions && (
        <>
          <Button variant="text" color="secondary" onClick={onDiscardChanges} disabled={isCancelDisabled}>
            Cancel
          </Button>
          <Button variant="contained" onClick={onSave} disabled={isSaveDisabled} loading={pendingSaveAction === "save"}>
            Save
          </Button>
          <Button
            variant="outlined"
            onClick={onSaveAndExit}
            disabled={isSaveDisabled}
            loading={pendingSaveAction === "saveAndExit"}
          >
            Save &amp; Exit
          </Button>
          {publishTransition && (
            <Button
              variant="outlined"
              disabled={!investorCommunication.isReadyForPublishing || isStatusChangeDisabled}
              startIcon={<publishTransition.Icon />}
              onClick={() => onStatusChange(publishTransition)}
            >
              {publishTransition.label}
            </Button>
          )}
          <ActionsMenuButton
            disabled={isSaving}
            items={[
              ...(unpublishTransition
                ? [
                    {
                      label: unpublishTransition.label,
                      icon: <unpublishTransition.Icon />,
                      disabled: isStatusChangeDisabled,
                      onClick: () => onStatusChange(unpublishTransition),
                    },
                  ]
                : []),
              { label: "Delete", icon: <DeleteIcon color="error" />, onClick: onDelete },
            ]}
          />
        </>
      )}
    </GeneralPageHeader>
  );
};

export default InvestorCommunicationDetailsPageHeader;
